// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".animate__animated[data-v-50d21293]{-webkit-animation-duration:.5s;animation-duration:.5s}", ""]);
// Exports
module.exports = exports;
